var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verify-content" }, [
    !_vm.translationsLoaded
      ? _c("div", [_c("circle-loader")], 1)
      : _c("div", [
          _c(
            "div",
            { staticClass: "account-page ctsform" },
            [
              false
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Account.VerificationByPin.InfoText")) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.resendPin()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Account.VerificationByPin.Resend"))
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("form", { attrs: { id: "confirmEmalByPinForm" } }, [
                (_vm.page === "verify_email" || _vm.page === "verify_mob") &&
                _vm.state === "initial"
                  ? _c("div", { staticClass: "form-actions" }, [
                      _vm.page === "verify_email"
                        ? _c(
                            "div",
                            { staticClass: "control-block" },
                            [
                              _vm.personalDetails
                                ? _c("p", {
                                    staticClass: "verifyText",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.EmailText",
                                          {
                                            n: _vm.personalDetails.PrimaryEmail
                                          }
                                        )
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "success", "x-large": "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resendPin()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isAuthServerEnabled
                                          ? _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.SendEmail"
                                            )
                                          : _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.SendEmail.AuthServer"
                                            )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "control-block" },
                            [
                              _vm.personalDetails
                                ? _c("p", {
                                    staticClass: "verifyText",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SMSText",
                                          { n: _vm.personalDetails.MobilePhone }
                                        )
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "success", "x-large": "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resendPin()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SendSMS"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ])
                  : (_vm.page === "verify_email" ||
                      _vm.page === "verify_mob") &&
                    _vm.state === "sent"
                  ? _c("div", { staticClass: "form-actions" }, [
                      _vm.page === "verify_email"
                        ? _c(
                            "div",
                            [
                              _vm.personalDetails
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SentEmail",
                                          {
                                            n: _vm.personalDetails.PrimaryEmail
                                          }
                                        )
                                      )
                                    }
                                  })
                                : _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SentEMLForUserTryingLogin"
                                        )
                                      )
                                    }
                                  }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "control-block pin-block",
                                  class: { filled: _vm.pinCode }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.pinCode,
                                        expression: "pinCode",
                                        modifiers: { trim: true }
                                      }
                                    ],
                                    staticClass: "pin-input",
                                    attrs: {
                                      type: "text",
                                      maxlength:
                                        _vm.validationRules &&
                                        _vm.validationRules
                                          .validationPinCodeLength,
                                      autocomplete: "off",
                                      id: "pin"
                                    },
                                    domProps: { value: _vm.pinCode },
                                    on: {
                                      focusout: function($event) {
                                        !_vm.verifyDetails.pinCode
                                          ? (_vm.errorMessages.pinCode = true)
                                          : (_vm.errorMessages.pinCode = false)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.pinCode = $event.target.value.trim()
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "control-label pin-label" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.SequentialVerification.VerifyByPin.Verification.EnterPin"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm.errorMessages.pinCode
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_missing" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCode"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessages.pinNonDigit
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_not_digit" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCodeNonDigit"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessages.pinLength
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_length" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCodeLength"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    type: "submit",
                                    "x-large": "",
                                    id: _vm.isVerEmail
                                      ? "btn_verifyByPinEmail"
                                      : "btn_verifyByPinPhone"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.verifyByPIN()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.VerificationByPin.Verify"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                { staticClass: "changeDetailText" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.SequentialVerification.ChangeDetail.ResendEmailText"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn changeBtn",
                                  attrs: { "x-large": "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resendPin()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.ChangeDetail.ResendEmail"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _vm.personalDetails
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SentSMS",
                                          { n: _vm.personalDetails.MobilePhone }
                                        )
                                      )
                                    }
                                  })
                                : _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerifyByPin.Verification.SentSMSForUserTryingLogin"
                                        )
                                      )
                                    }
                                  }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "control-block pin-block",
                                  class: { filled: _vm.pinCode }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.pinCode,
                                        expression: "pinCode",
                                        modifiers: { trim: true }
                                      }
                                    ],
                                    staticClass: "pin-input",
                                    attrs: {
                                      type: "text",
                                      maxlength:
                                        _vm.validationRules &&
                                        _vm.validationRules
                                          .validationPinCodeLength,
                                      autocomplete: "off",
                                      id: "pin"
                                    },
                                    domProps: { value: _vm.pinCode },
                                    on: {
                                      focusout: function($event) {
                                        !_vm.verifyDetails.pinCode
                                          ? (_vm.errorMessages.pinCode = true)
                                          : (_vm.errorMessages.pinCode = false)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.pinCode = $event.target.value.trim()
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "control-label pin-label" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.SequentialVerification.VerifyByPin.Verification.EnterPin"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm.errorMessages.pinCode
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_missing" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCode"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessages.pinNonDigit
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_not_digit" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCodeNonDigit"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessages.pinLength
                                  ? _c("div", {
                                      staticClass: "vmsg invalid",
                                      attrs: { id: "err_msg_phone_length" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.VerificationByPin.ErrorMsg.PinCodeLength"
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    type: "submit",
                                    "x-large": "",
                                    id: _vm.isVerEmail
                                      ? "btn_verifyByPinEmail"
                                      : "btn_verifyByPinPhone"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.verifyByPIN()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.VerificationByPin.Verify"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                { staticClass: "changeDetailText" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.SequentialVerification.ChangeDetail.ResendSMSText"
                                      )
                                    ) + " "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn changeBtn",
                                  attrs: { "x-large": "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resendPin()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.ChangeDetail.ResendSMS"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ])
                  : _c("div", [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.Verification.UnexpectedPageAndState",
                              { page: _vm.page, state: _vm.state }
                            )
                          )
                        }
                      })
                    ]),
                _vm._v(" "),
                _vm.isLoggedIn
                  ? _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c("v-card-text", { staticClass: "changeDetailText" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.SequentialVerification.VerifyByPin.Verification.EnteredWrongData." +
                                  _vm.page
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn changeBtn",
                            attrs: { "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changeDetail(_vm.wrongDetail.channel)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.SequentialVerification.VerifyByPin.Verification.EditHere"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "ProcessingDialog",
                {
                  attrs: {
                    isDialogPersistent: true,
                    isProcessing: _vm.isProcessing,
                    isSuccess: !_vm.transactionError,
                    processingTitle: _vm.processingTitle,
                    processingText: _vm.processingText,
                    successTitle: _vm.successTitle,
                    successText: _vm.successText,
                    errorTitle: _vm.errorTitle,
                    closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
                  },
                  on: { close: _vm.closeVerificationDialog },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "text-error" }, slot: "text-error" },
                    [
                      _c(
                        "p",
                        { staticClass: "generic-icon-note" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { color: "error" } },
                            [_vm._v("error")]
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.errorText))])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "response-error" }, [
                        _vm._v(_vm._s(_vm.transactionError))
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.Join.Dialog.Error.Text.ContactSupport"
                            )
                          )
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6518bb03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6518bb03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/VerifyByPin.vue
// module id = null
// module chunks = 